import React, { useEffect, useMemo, useState } from 'react'

import { MainTabsV2 } from '@labrav/react-components'

import { useStyles } from './BuyerJourneyMap.styles'
import awsLogo from '../../../common/images/aws.png'
import { LoadingStateComponent } from '@labrav/common'
import { useDispatch, useSelector } from '../../../store/hooks'
import { useParams } from 'react-router-dom'
import { getBuyersJourneyContractsData } from '../../../modules/buyers/action'
import { LoadingTypes, isLoading, useAccountId } from '@labrav/common'
import { BuyerJourneyContracts } from '../../../modules/buyers/types'
import { JourneyMapComponentItem } from './JourneyMapComponentItem/JourneyMapComponentItem'

export const BuyerJourneyMap: React.FC = () => {
  const { classes } = useStyles()
  const dispatch = useDispatch()
  const accountId = useAccountId({ product: 'flyout' }) || ''
  const { buyerId } = useParams()
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const [productTypeTabs, setProductTypeTabs] = useState<
    {
      label: string
      key: string
      icon: JSX.Element
      renderElement: JSX.Element
    }[]
  >([])

  const isLoadingState = useSelector<boolean>(state =>
    isLoading(state.loading)(LoadingTypes.BUYER_JOURNEY_CONTRACTS)
  )

  const buyerContracts = useSelector<BuyerJourneyContracts[]>(
    state => state.BuyersOverView.buyerContracts
  )

  const handleProductTypeTabChange = (index: number) => {
    setActiveTabIndex(index)
  }

  useEffect(() => {
    if (accountId && buyerId) {
      dispatch(
        getBuyersJourneyContractsData({
          partnerId: accountId,
          labraBuyerDetailsId: buyerId,
        })
      )
    }
  }, [accountId, buyerId, dispatch])

  useEffect(() => {
    const tabs = buyerContracts.map(contract => {
      return {
        label: contract.contractName,
        key: contract.contractId,
        icon: (
          <img
            src={awsLogo}
            crossOrigin="anonymous"
            className={classes.awsImg}
          />
        ),
        renderElement: (
          <JourneyMapComponentItem
            contractId={contract.contractId}
            contractType={contract.contractType}
          />
        ),
      }
    })

    setProductTypeTabs(tabs)
    setActiveTabIndex(0)
  }, [buyerContracts, classes.awsImg])

  const selectedContent = useMemo(() => {
    return productTypeTabs?.find((_, index) => index === activeTabIndex)
      ?.renderElement
  }, [activeTabIndex, productTypeTabs])

  return (
    <>
      {isLoadingState && !selectedContent ? (
        <LoadingJourneyComponent />
      ) : (
        <div data-testid="buyer-journey-map" className={classes.root}>
          <MainTabsV2
            activeTabIndex={activeTabIndex}
            onChange={handleProductTypeTabChange}
            tabs={productTypeTabs}
          />
          <div className={classes.journey}>{selectedContent}</div>
        </div>
      )}
    </>
  )
}

export const LoadingJourneyComponent: React.FC = () => {
  const { classes } = useStyles()
  return (
    <div className={classes.loading} data-testid="buyer-journey-map-loading">
      <LoadingStateComponent
        heading="Loading your buyer journey map."
        description="It may take a few moments, please wait."
      />
    </div>
  )
}
